import React from "react";

const OtpModal = ({ otp, setOtp, otpError, handleVerifyOtp, handleResendOtp }) => {
  const handleOtpChange = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 6); // Allow only numbers & max 6 digits
    setOtp(value);
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white p-8 rounded-lg shadow-lg w-96">
        <h3 className="text-2xl font-semibold mb-4 text-gray-900">Verify OTP</h3>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handleVerifyOtp();
          }}
          className="flex flex-col items-center"
        >
          <input
            type="text"
            value={otp}
            onChange={handleOtpChange}
            maxLength="6"
            className="w-full text-center text-lg border-2 border-gray-300 rounded-md p-2 text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
            placeholder="Enter 6-digit OTP"
            inputMode="numeric"
            pattern="\d{6}"
            required
          />
          {otpError && <p className="text-red-500 text-base mt-2">{otpError}</p>}
          <div className="mt-4 flex justify-between w-full">
            <button type="submit" className="bg-indigo-600 text-white px-4 py-2 rounded-md font-semibold hover:bg-indigo-700">
              Verify OTP
            </button>
            <button
              type="button"
              onClick={handleResendOtp}
              className="bg-gray-500 text-white px-4 py-2 rounded-md font-semibold hover:bg-gray-600"
            >
              Resend OTP
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default OtpModal;